import React, {FC} from 'react';
import classNames from 'classnames';

import * as styles from './styles.module.scss';

interface FooterProps {
	className?: string
}

export const Footer: FC<FooterProps> = ({
	className,
}) => {
	// const {screen} = useCtxConfig();
	return (
		<div className={classNames(styles.footer, className)}>
			{/* {screen?.bg} */}
		</div>
	);
};
